import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AvailabilityBadge from './AvailabilityBadge';
import { fetchFeaturedProducts } from '../services/products';
import { getStorageUrl } from '../services/api';
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchFeaturedProducts(12);
        if (!cancelled) setProducts(Array.isArray(data) ? data : []);
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load featured products.');
          setProducts([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  const getImageUrl = (image) => getStorageUrl(image);

  const handleProductClick = (productId) => {
    navigate(`/products/${productId}`);
  };

  const handleViewAll = () => {
    navigate('/products');
  };

  if (loading) {
    return (
      <section className="featured-products-section">
        <div className="featured-products-container">
          <div className="section-header">
            <h5 className="section-title">Featured Products</h5>
          </div>
          <div className="featured-products-loading">Loading featured products...</div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="featured-products-section">
        <div className="featured-products-container">
          <div className="section-header">
            <h2 className="section-title">Featured Products</h2>
          </div>
          <div className="featured-products-error">{error}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="featured-products-section">
      <div className="featured-products-container">
        <div className="section-header">
          <h2 className="section-title">Featured Products</h2>
          <button className="view-all-btn" onClick={handleViewAll}>
            View All Products <span>&gt;</span>
          </button>
        </div>

        {products.length === 0 ? (
          <div className="featured-products-empty">
            No featured products at the moment. Check back soon or browse all products.
          </div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <div
                key={product.id}
                className="product-card"
                onClick={() => handleProductClick(product.id)}
              >
                <div className="product-image">
                  {getImageUrl(product.image) ? (
                    <img src={getImageUrl(product.image)} alt={product.name} />
                  ) : (
                    <div className="product-image-placeholder">No image</div>
                  )}
                  <AvailabilityBadge availabilityType={product.availability_type} size="small" />
                </div>
                <h5 className="featured-product-title">{product.name}</h5>
                <p className="product-description">
                  {product.subtitle || (product.description && product.description.slice(0, 60)) || ''}
                  {product.description && product.description.length > 60 ? '…' : ''}
                </p>
                <button className="view-details-btn" type="button">
                  View Details <span>&gt;</span>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default FeaturedProducts;
